class InventoryStatus {
  constructor() {
    this.statusElement = document.querySelector('[data-inventory-status="true"]');
    if (!this.statusElement) {
      return;
    }

    this.physicalStoreElement = document.querySelector('.delivery-option__physical-store');
    this.deliveryElement = document.querySelector('.delivery-option__delivery');
    this.deliveryOptionsElement = document.querySelector('.delivery-options');
    this.giftlistDomain = this.statusElement.getAttribute('data-giftlist-domain');
    this.proxyToken = this.statusElement.getAttribute('data-proxy-token');

    this.init();
  }

  updateDeliveryOptions(physicalStoreStock, deliveryStock) {
    if (this.physicalStoreElement) {
      this.physicalStoreElement.classList.toggle('delivery-option--no-stock', physicalStoreStock <= 0);
    }

    if (this.deliveryElement) {
      this.deliveryElement.classList.toggle('delivery-option--no-stock', deliveryStock <= 0);
    }
  }

  calculateStockTotals(inventoryLevels) {
    let totalStock = 0;
    let physicalStoreStock = 0;
    let deliveryStock = 0;

    inventoryLevels.forEach(level => {
      const quantity = parseInt(level.quantity) || 0;
      totalStock += quantity;

      if (level.location.isPhysicalStore) {
        physicalStoreStock += quantity;
      } else {
        deliveryStock += quantity;
      }
    });

    return { totalStock, physicalStoreStock, deliveryStock };
  }

  formatStock(stock) {
    if (stock <= 0) {
      return '';
    };

    return ` (${stock > 50 ? '> 50' : stock})`;
  }

  async init() {
    try {
      const response = await fetch(`${this.giftlistDomain}/proxy/shopify-admin/inventory?authorization=fixed`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.proxyToken}`
        },
        body: JSON.stringify({
          sku: this.statusElement.dataset.sku
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (!data.inventoryLevels) {
        throw new Error('No inventory levels found for this product')
      }

      const { totalStock, physicalStoreStock, deliveryStock } = this.calculateStockTotals(data.inventoryLevels);
    
      const hasPhysicalStores = data.inventoryLevels.some(inventoryLevel => inventoryLevel.location.isPhysicalStore);

      const statusText = document.querySelector('.dreambaby-store-inventory-status__text');
      if (statusText) {
        const originalText = statusText.textContent;
        statusText.textContent = `${originalText} ${this.formatStock(totalStock)}`;
      }

      this.updateDeliveryOptions(physicalStoreStock, deliveryStock);

      const physicalStoreTitle = document.querySelector('.delivery-option__physical-store .delivery-option__title');
      if (physicalStoreTitle) {
        const originalText = physicalStoreTitle.textContent;
        physicalStoreTitle.textContent = originalText + this.formatStock(physicalStoreStock);
      }

      if (hasPhysicalStores) {
        this.physicalStoreElement.classList.remove('is-hidden');
      }

      const deliveryTitle = document.querySelector('.delivery-option__delivery .delivery-option__title');
      if (deliveryTitle) {
        const originalText = deliveryTitle.textContent;
        deliveryTitle.textContent = originalText + this.formatStock(deliveryStock);
      }

      this.deliveryOptionsElement.classList.remove('is-loading');
    } catch (error) {
      console.error('Error fetching inventory:', error);
    } finally {
      this.statusElement.classList.remove('is-loading');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new InventoryStatus());
} else {
  new InventoryStatus();
}
